import { darkThemeSelector, Divider, fade, palette, styled, zIndexes } from '@meterup/atto';

import { sidebarVars } from './vars';

const sidebarAtomsVars = {
  zIndices: {
    base: zIndexes.dockArea,
    sticky: zIndexes.dockArea + 1,
    divider: zIndexes.dockArea + 2,
  },
};

export const SidebarGroup = styled('div', {
  position: 'relative',
  zIndex: sidebarAtomsVars.zIndices.base,
  display: 'flex',
  width: '100%',

  '&:empty': {
    display: 'none',
  },

  variants: {
    direction: {
      column: {
        flexDirection: 'column',
      },
      row: {
        flexDirection: 'row',
      },
    },
    hasTrees: {
      true: {
        padding: `$${sidebarVars.padding.ends} 0`,
      },
      false: {
        padding: `$${sidebarVars.padding.ends} $${sidebarVars.padding.sides}`,
      },
    },
    minimized: {
      true: {},
      false: {},
    },
    sticky: {
      true: {
        position: 'sticky',
        top: 0,
        zIndex: sidebarAtomsVars.zIndices.sticky,
        background: `linear-gradient(180deg, ${fade(palette.bgApplicationLight, 1)} 0%, ${fade(palette.bgSurfaceLight, 1)} 100%)`,
        '&': {
          boxShadow: [
            `0 1px 1px 0 ${fade(palette.gray900, 0.08)}`,
            `0 1px 3px 0 ${fade(palette.gray900, 0.12)}`,
          ],
        },

        [darkThemeSelector]: {
          background: `linear-gradient(180deg, ${fade(palette.bgApplicationDark, 1)} 0%, ${fade(palette.bgSurfaceDark, 1)} 100%)`,
          boxShadow: [
            `0 1px 1px 0 ${fade(palette.gray900, 0.8)}`,
            `0 1px 3px 0 ${fade(palette.gray900, 0.7)}`,
          ],
        },
      },
      false: {},
    },
  },

  compoundVariants: [
    {
      direction: 'row',
      minimized: false,
      css: {
        flexDirection: 'row',
      },
    },
    {
      direction: 'row',
      minimized: true,
      css: {
        flexDirection: 'column',
      },
    },
  ],

  defaultVariants: {
    direction: 'column',
    hasTrees: false,
    minimized: false,
  },
});
SidebarGroup.displayName = 'SidebarGroup';

export const SidebarDivider = styled(Divider, {
  position: 'relative',
  zIndex: sidebarAtomsVars.zIndices.divider,

  variants: {
    nested: {
      true: {
        margin: `$4 $${sidebarVars.padding.sides}`,
      },
      false: {
        margin: `0 $${sidebarVars.padding.sides * 2}`,
      },
    },
  },

  defaultVariants: {
    nested: false,
  },
});
SidebarDivider.displayName = 'SidebarDivider';
